"use client"
import {useState} from "react";
import {Copy} from "lucide-react";
import DOMPurify from 'isomorphic-dompurify';

export default function CopyLink({copy, dict}) {
    const [isCopiedTooltip, setIsCopiedTooltip] = useState(false)

    const getTextFromHtml = (html: string) => {
        const clean = DOMPurify.sanitize(html, {
            ALLOWED_TAGS: [], // Remove all HTML tags
            ALLOWED_ATTR: [] // Remove all attributes
        });

        return clean.trim();
    };

    const cleanText = getTextFromHtml(copy);

    return <>
        <Copy
            className="text-primary-button cursor-pointer"
            size={24}
            onClick={() => {
                navigator.clipboard.writeText(cleanText)
                setIsCopiedTooltip(true)
                setTimeout(() => setIsCopiedTooltip(false), 2000)
            }}
        />
        <div
            className={`absolute -bottom-7 -translate-x-1/2 left-1/2 min-w-35 text-center transition-opacity bg-white text-tag px-3 py-1 rounded-full ${isCopiedTooltip ? 'opacity-100' : 'opacity-0'}`}>{dict.copylink.message}</div>
    </>
}